import { FC, useCallback } from "react";
import { DrawerSection } from "./DrawerSection";
import { Box, Button, Skeleton, useBoolean } from "@chakra-ui/react";
import { Text } from "../../components/Typography";
import {
  CreditPackDrawer,
  CreditPackDrawerPopupReason,
} from "./CreditPackDrawer";
import { useFeatureCosts } from "api/payments/useFeatureCosts";
import { theme } from "@ovou-inc/ovou-ui";
import { useCurrentTeamCredits } from "api/payments/useCurrentTeamCredits";
import { ANALYTICS_EVENTS } from "constants/analyticEvents";
import { useAnalytics } from "context/Analytics";

const gradientTextColor = "linear-gradient(94deg, #DA1B7D 1.16%, #FF643A 100%)";

export const AvailableCredits: FC = () => {
  const [isOpen, { on: openCreditPacksDrawer, off: closeCreditPacksDrawer }] =
    useBoolean(false);
  const analytics = useAnalytics();

  const { data: creditResponse } = useCurrentTeamCredits();
  const { data: featureCosts } = useFeatureCosts();

  const clickBuyCredits = useCallback(() => {
    analytics.track(ANALYTICS_EVENTS.BUY_CREDITS_CLICK, {});
    openCreditPacksDrawer();
  }, [analytics, openCreditPacksDrawer]);

  if (!creditResponse || !featureCosts) {
    return (
      <Skeleton
        height="107px"
        borderRadius="10px"
        startColor={theme.palette.ui.greys.grey5}
        endColor={theme.palette.ui.greys.grey4}
      />
    );
  }

  const credits = creditResponse.available_credits;

  return (
    <>
      <DrawerSection>
        <Box display="flex" flexDirection="column" gap="19px">
          <Box display="flex" flexDirection="row">
            <Box
              display="flex"
              flexDirection="row"
              gap="4px"
              alignItems="flex-end"
              flex="1"
            >
              <Text
                fontSize="32px"
                fontStyle="normal"
                fontWeight="800"
                lineHeight="110%"
                letterSpacing="-0.32px"
                background={gradientTextColor}
                backgroundClip="text"
              >
                {credits}
              </Text>
              <Text
                fontSize="14px"
                fontStyle="normal"
                fontWeight="400"
                lineHeight="150%"
                background={gradientTextColor}
                backgroundClip="text"
              >
                Available Credits
              </Text>
            </Box>
            <Box>
              <Button
                background={gradientTextColor}
                color="white"
                width="108px"
                height="32px"
                padding="16px 32px"
                float="right"
                _hover={{
                  background: gradientTextColor,
                }}
                _active={{
                  background: gradientTextColor,
                }}
                _focus={{
                  background: gradientTextColor,
                }}
                onClick={clickBuyCredits}
              >
                Buy Credits
              </Button>
            </Box>
          </Box>

          {credits > 0 ? (
            featureCosts.map(item => (
              <Text key={item.id} fontSize="14px" lineHeight="150%">
                {item.cost} credit = 1 {item.label}
              </Text>
            ))
          ) : (
            <Text
              fontSize="14px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="150%"
            >
              You need credits to enrich contacts.
            </Text>
          )}
        </Box>
      </DrawerSection>

      <CreditPackDrawer
        popupReason={CreditPackDrawerPopupReason.BUY_CREDITS}
        isOpen={isOpen}
        onClose={closeCreditPacksDrawer}
      />
    </>
  );
};
